<script setup lang="ts">
import { onMounted, onUnmounted, useTemplateRef } from 'vue';

import PackageStepNewAirRoadSection from '@/components/sections/PackageStepNewAirRoadSection.vue';
import { useNewAirRoadViewStore } from '@/stores/useNewAirRoadViewStore';
import * as airRoadConstants from '@/constants/airRoad';

const newAirRoadViewStore = useNewAirRoadViewStore();

const packageFormRef = useTemplateRef<HTMLFormElement>('packageForm');

onMounted(function () {
  newAirRoadViewStore.setPackageFormElement(packageFormRef.value);
});

onUnmounted(function () {
  newAirRoadViewStore.setPackageFormElement(null);
});
</script>

<template>
  <v-form
    ref="packageForm"
    v-model="
      newAirRoadViewStore.bookingStepValidationState[
        airRoadConstants.bookingStepValues.PACKAGE
      ]
    "
    :class="$style.packageNewAirRoadStepForm"
    data-testid="packageNewAirRoadStepForm"
    validate-on="lazy"
  >
    <input type="submit" class="hidden" disabled />
    <PackageStepNewAirRoadSection
      v-model="newAirRoadViewStore.bookingState"
      :air-road-booking-job="newAirRoadViewStore.data.airRoadBookingJob"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.packageNewAirRoadStepForm {
}
</style>
